/* global axios */
import ApiClient from '../ApiClient';

class ContactConversationApi extends ApiClient {
  constructor() {
    // IMPORTANT: Review this base path and potentially change it to match
    // your backend routes for contact-specific conversations, e.g.:
    // super('contacts/{contactId}/conversations', { accountScoped: true });
    super('conversations', { accountScoped: true });
  }

  get({
    inboxId,
    status,
    assigneeType,
    page,
    labels,
    teamId,
    conversationType,
    sortBy,
    updatedWithin,
    // Potentially add contactId here if needed for the API call
  }) {
    // IMPORTANT: Review this URL and its parameters
    return axios.get(this.url, {
      params: {
        inbox_id: inboxId,
        team_id: teamId,
        status,
        assignee_type: assigneeType,
        page,
        labels,
        conversation_type: conversationType,
        sort_by: sortBy,
        updated_within: updatedWithin,
      },
    });
  }

  filter(payload) {
    // IMPORTANT: Review this URL
    return axios.post(`${this.url}/filter`, payload.queryData, {
      params: {
        page: payload.page,
      },
    });
  }

  filter_grouped(payload) {
    // IMPORTANT: Review this URL
    return axios.post(`${this.url}/filter_grouped`, payload.queryData, {
      params: {
        page: payload.page,
      },
    });
  }

  


  search({ q }) {
    // IMPORTANT: Review this URL
    return axios.get(`${this.url}/search`, {
      params: {
        q,
        page: 1,
      },
    });
  }

  toggleStatus({ conversationId, status, snoozedUntil = null }) {
    // IMPORTANT: Review this URL
    return axios.post(`${this.url}/${conversationId}/toggle_status`, {
      status,
      snoozed_until: snoozedUntil,
    });
  }

  resolveWithClosingNote({
    conversationId,
    convStatusTag,
    convSummary,
    labels = [],
    labelTarget = 'contact',
    automatic = false,
  }) {
    return axios.post(
      `${this.url}/${conversationId}/resolve_with_closing_note`,
      {
        conv_status_tag: convStatusTag,
        conv_summary: convSummary,
        labels,
        label_target: labelTarget,
        automatic,
      }
    );
  }

  closingNoteSuggestion({ conversationId }) {
    return axios.post(`${this.url}/${conversationId}/closing_note_suggestion`);
  }

  togglePriority({ conversationId, priority }) {
    // IMPORTANT: Review this URL
    return axios.post(`${this.url}/${conversationId}/toggle_priority`, {
      priority,
    });
  }

  assignAgent({ conversationId, agentId }) {
    // IMPORTANT: Review this URL
    return axios.post(
      `${this.url}/${conversationId}/assignments?assignee_id=${agentId}`,
      {}
    );
  }

  assignTeam({ conversationId, teamId }) {
    const params = { team_id: teamId };
    // IMPORTANT: Review this URL
    return axios.post(`${this.url}/${conversationId}/assignments`, params);
  }

  markMessageRead({ id }) {
    // IMPORTANT: Review this URL
    return axios.post(`${this.url}/${id}/update_last_seen`);
  }

  markMessagesUnread({ id }) {
    // IMPORTANT: Review this URL
    return axios.post(`${this.url}/${id}/unread`);
  }

  toggleTyping({ conversationId, status, isPrivate }) {
    // IMPORTANT: Review this URL
    return axios.post(`${this.url}/${conversationId}/toggle_typing_status`, {
      typing_status: status,
      is_private: isPrivate,
    });
  }

  mute(conversationId) {
    // IMPORTANT: Review this URL
    return axios.post(`${this.url}/${conversationId}/mute`);
  }

  unmute(conversationId) {
    // IMPORTANT: Review this URL
    return axios.post(`${this.url}/${conversationId}/unmute`);
  }

  meta({ inboxId, status, assigneeType, labels, teamId, conversationType }) {
    // IMPORTANT: Review this URL and its parameters
    return axios.get(`${this.url}/meta`, {
      params: {
        inbox_id: inboxId,
        status,
        assignee_type: assigneeType,
        labels,
        team_id: teamId,
        conversation_type: conversationType,
      },
    });
  }

  sendEmailTranscript({ conversationId, email }) {
    // IMPORTANT: Review this URL
    return axios.post(`${this.url}/${conversationId}/transcript`, { email });
  }

  updateCustomAttributes({ conversationId, customAttributes }) {
    // IMPORTANT: Review this URL
    return axios.post(`${this.url}/${conversationId}/custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  fetchParticipants(conversationId) {
    // IMPORTANT: Review this URL
    return axios.get(`${this.url}/${conversationId}/participants`);
  }

  updateParticipants({ conversationId, userIds }) {
    // IMPORTANT: Review this URL
    return axios.patch(`${this.url}/${conversationId}/participants`, {
      user_ids: userIds,
    });
  }

  getAllAttachments(conversationId) {
    // IMPORTANT: Review this URL
    return axios.get(`${this.url}/${conversationId}/attachments`);
  }

  showByContact(id) {
    return axios.get(`${this.url}/show_by_contact?contactId=${id}`);
  }

  getGroupedByContact({
    inboxId,
    status,
    assigneeType,
    page,
    labels,
    teamId,
    conversationType,
    sortBy,
    updatedWithin,
  }) {
    return axios.get(`${this.url}/grouped_by_contact`, {
      params: {
        inbox_id: inboxId,
        team_id: teamId,
        status,
        assignee_type: assigneeType,
        page,
        labels,
        conversation_type: conversationType,
        sort_by: sortBy,
        updated_within: updatedWithin,
      },
    });
  }
}

export default new ContactConversationApi();
